import { DEFAULT_PAGE_SIZE } from 'pages/CrewTimeline/const';

import { EXTRA_BOARD_CLASSIFICATION_OPTION } from './OperatorTypeFilter/const';

export const AVAILABILITY_STATUS_ALL = 'All';
export const AVAILABILITY_STATUS_IDLE = 'Available';
export const AVAILABILITY_STATUS_ON_ASSIGNMENT = 'Driving';
export const AVAILABILITY_STATUS_ON_ABSENCE = 'On absence';
export const AVAILABILITY_STATUS_ON_PROTECTION = 'On protection';
export const AVAILABILITY_STATUS_RESTING = 'Resting';
export const AVAILABILITY_STATUS_UNKNOWN = 'Unknown';
export const AVAILABILITY_STATUS_VALUE_IDLE = 'idle';
export const AVAILABILITY_STATUS_VALUE_ON_ASSIGNMENT = 'onAssignment';
export const AVAILABILITY_STATUS_VALUE_ON_ABSENCE = 'onAbsence';
export const AVAILABILITY_STATUS_VALUE_ON_PROTECTION = 'onProtection';
export const AVAILABILITY_STATUS_VALUE_RESTING = 'resting';
// TODO: CHECK
export const AVAILABILITY_STATUS_VALUE_UNKNOWN = 'unknown';

export const ALL_GROUPS_ID = '0000000000000000';

export const EMPTY_FORM_VALUES = {
	display: 1,
	pageSize: DEFAULT_PAGE_SIZE,
	text: '',
	dateRange: '',
	group: '',
	crewMember: '',
	status: '',
	locationAvailabilityCity: [],
	operatorType: EXTRA_BOARD_CLASSIFICATION_OPTION,
};
